/* Κινητό: μία γραμμή ανά στατιστικό, ετικέτα αριστερά / τιμή δεξιά.
   Από md και πάνω επανέρχεται στα 3 ανά σειρά, όπως ήταν. */
const Stat = ({ label, value }) => (
  <p className="flex w-full items-baseline justify-between gap-4 border-b border-gray-300 py-2.5 last:border-b-0 dark:border-gray-600 md:block md:w-1/3 md:border-b-0 md:py-0">
    <span className="text-gray-600 dark:text-gray-300 md:text-inherit">{label}:</span>{' '}
    <span className="font-semibold md:font-normal">{value}</span>
  </p>
);

export const Overall = ({currentSeason, statsPerSeasons, userOverall}) => {
  let profitClass, formattedProfit, formattedSeason, totalBets, totalYield, betsWon, betsLost, betsVoided, successRate, averageOdds, seasonProfit
  
  if (userOverall.length > 0 && userOverall[0].totalprofit) {
    profitClass = userOverall[0].totalprofit >= 0 ? 'text-green-400' : 'text-red-400';
    formattedProfit = userOverall[0].totalprofit >= 0 ? `+${userOverall[0].totalprofit}` : `${userOverall[0].totalprofit}`;
  } else {
    formattedProfit = 0
  }

  if (currentSeason && typeof currentSeason === 'string') {
      const seasonStartYear = currentSeason.split('-')[0];
      const seasonEndYear = currentSeason.split('-')[1];
  
      formattedSeason = `08/${seasonStartYear}-07/${seasonEndYear}`;
    }
  
  if (statsPerSeasons.length > 0 ) {
    totalBets = statsPerSeasons[0].totalbets || 0
    totalYield = statsPerSeasons[0].yield || 0;
    betsWon = statsPerSeasons[0].won || 0
    betsLost = statsPerSeasons[0].lost || 0
    betsVoided = statsPerSeasons[0].void || 0
    successRate = statsPerSeasons[0].successrate || 0
    averageOdds = statsPerSeasons[0].averageodds || 0
    seasonProfit = statsPerSeasons[0].seasonprofit || 0
  } 
  
  

  return (
    <>
      <div className='w-full bg-betblue overflow-x-auto shadow-md sm:rounded-t-lg'>
        <div className='flex flex-col sm:flex-row sm:justify-between sm:items-center p-4'>
          <h2 className="mb-1 text-xl font-medium text-white dark:text-white">Προγνωστικά</h2>
          <p className="text-xl text-white">Overall Profit: <span className={profitClass}>{formattedProfit}</span></p>
        </div>
      </div>
      <div className="bg-gray-100 flex flex-col md:flex-row flex-wrap justify-between items-stretch md:items-center p-4 text-left md:text-center dark:bg-gray-700 dark:border-gray-700">
        <Stat label="Season" value={formattedSeason} />
        <Stat label="Won" value={betsWon || 0} />
        <Stat label="Success rate" value={successRate !== undefined ? `${successRate}%` : '0%'} />
        <Stat label="Total bets" value={totalBets || 0} />
        <Stat label="Lost" value={betsLost || 0} />
        <Stat label="Yield" value={totalYield !== undefined ? `${totalYield}%` : '0%'} />
        <Stat label="Avg odds" value={averageOdds || 0} />
        <Stat label="Void" value={betsVoided || 0} />
        <Stat label="Profit" value={seasonProfit || 0} />
      </div>
    </>
  );
};
